import React from 'react';
import Tooltip from './Tooltip';
import { Icon } from '../../../subkit-ui';
import { jsx as _jsx } from "react/jsx-runtime";
export var TooltipLabel = function TooltipLabel(_ref) {
  var tooltip = _ref.tooltip;
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "top",
    trigger: "hover",
    tooltip: tooltip,
    children: /*#__PURE__*/_jsx(Icon, {
      name: "question-circle",
      style: {
        color: 'gray'
      }
    })
  });
};